// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"8b90f196","275":"732234a9","483":"e29c58f0","492":"ed0db579","549":"84f7817f","855":"4f1d9ff3","909":"4badcf9a"}[chunkId] + ".chunk.js";
};